const namespace = '[DISPATCH_LIST]';
export const DISPATCH_LIST_FETCH_DISPATCHES = `${namespace} FETCH DISPATCHES`;
export const DISPATCH_LIST_CREATE_DISPATCH = `${namespace} CREATE_PAGINATION`;
export const DISPATCH_LIST_SET_DISPATCHES = `${namespace} SET DISPATCHES`;
export const DISPATCH_LIST_SET_PAGINATION = `${namespace} SET_PAGINATION`;
export const DISPATCH_LIST_REMOVE_DISPATCH = `${namespace} REMOVE_DISPATCH`;
